import { File, Room, RoomMessage, RoomMessageLog, RoomMessageStatus } from "../../proto/Global_pb";
import { FileSend } from "../fileHandler";
import { getStorage } from "../storage";
import { STORAGE_AUTHOR_HASH, STORAGE_USER_ID } from "../../constants/localstorage";
import { ChatSendMessage } from "../../proto/ChatSendMessage_pb";
import { protoRequestsObjectType } from "../../constants/protoTable";
import { getFileResolution } from "./message-utils";
import store from "../../store";
export type MessageType = Omit<ChatSendMessage.AsObject, "attachment"> & {
  attachment?: FileSend | string;
};
type ActionId = keyof protoRequestsObjectType;
export type MessageDetailType = {
  message: MessageType;
  roomType: Room.AsObject["type"];
  roomId: Room.AsObject["id"];
  actionId: ActionId;
};

export class MessageBuilder {
  constructor(protected message: MessageType) {}

  public withAttachment(attachment: FileSend | File.AsObject["token"]) {
    this.message.attachment = attachment;
    return this;
  }

  public getRequest() {
    return this;
  }
  public async getResponse(): Promise<RoomMessage.AsObject> {
    const replyToDetail: RoomMessage.AsObject["replyTo"] =
      this.message.replyTo !== "" || !!this.message.replyTo
        ? {
            ...store.getState().messages.messages[this.message.replyTo],
          }
        : undefined;
    const createTime = Math.floor(Date.now() / 1000);
    const { message } = this;
    const additional: Partial<RoomMessage.AsObject> = {
      author: { hash: getStorage(STORAGE_AUTHOR_HASH), user: { userId: getStorage(STORAGE_USER_ID), cacheId: "" }, room: { roomId: this.message.roomId } },
      messageId: message.randomId,
      messageVersion: "",
      status: RoomMessageStatus.SENDING,
      statusVersion: "",
      edited: false,
      createTime: createTime,
      updateTime: createTime,
      deleted: false,
      previousMessageId: message.randomId,
      extraType: RoomMessageLog.ExtraType.NO_EXTRA,
      documentId: "0",
      versionDocumentId: "0",
      replyTo: replyToDetail,
    };

    async function makeAttachmentRawFile() {
      const fileInstance = message.attachment;
      if (fileInstance instanceof FileSend) {
        let rawFile = fileInstance?.getRawFile();
        const { width, height } = await getFileResolution(message.messageType);
        if (rawFile) {
          additional.attachment = {
            token: (message.attachment as FileSend).token || ("" as string),
            name: rawFile.name,
            size: rawFile.size,
            width: width,
            height: height,
            duration: 0,
            cacheId: message.randomId,
            mime: rawFile.type,
            publicUrl: "",
          };
        }
      }
    }
    await makeAttachmentRawFile();
    return { ...message, ...additional } as RoomMessage.AsObject;
  }
}
